import { Component, ViewEncapsulation, output, input } from '@angular/core';
import { NgClass } from '@angular/common';

import { ApIconComponent } from '@ap/icon';

@Component({
    selector: 'ap-hamburger',
    templateUrl: './hamburger.component.html',
    styleUrls: ['./hamburger.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [NgClass, ApIconComponent]
})
export class ApHamburgerComponent {
    /**
     * Is hamburger menu open?
     * Defaults to false
     */
    public readonly isOpen = input(false);

    /**
     * Emits event if menu is toggled
     */
    public readonly toggleMenu = output<void>();
}
